import type { FeatureModule } from '@/core/platform/features/FeatureModule';
import { getEnv } from '@core/config/CoreEnvironmentService';

export class SwaggerFeatureModule {
  private static readonly definition: FeatureModule = {
    name: 'swagger',
    isEnabled: () => getEnv().NODE_ENV === 'development',
  };

  private constructor() {}

  public static getDefinition(): FeatureModule {
    return SwaggerFeatureModule.definition;
  }
}
